"use client";

import { Icon, Typography, useMediaQuery } from "@kyan/ui";

import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";
import { useIsTopBannerDismissed } from "#/store/app/alerts/isTopBannerDismissed";

export const TopBanner: React.FC = () => {
  const { showTopBanner, title, isDismissible } = useTopBannerFeatureFlag();
  const { setIsTopBannerDismissed } = useIsTopBannerDismissed();
  const { isSm } = useMediaQuery();

  if (!showTopBanner) return null;

  return (
    <div className="border-divider bg-background fixed inset-0 z-50 flex h-18 w-full items-center justify-center border-b bg-[url('/images/components/top-banner-light.png')] bg-cover bg-center dark:bg-[url('/images/components/top-banner-dark.png')]">
      <div className="flex flex-col items-center gap-1 sm:flex-row sm:gap-6">
        <Typography
          grotesk
          primary
          size={isSm ? 24 : 20}
          className="text-white"
        >
          {title}
        </Typography>
        <div className="hidden size-2.5 rounded-full bg-white/30 sm:block" />
        <Typography primary size={isSm ? 24 : 16} className="text-white">
          Trade with <i>zero</i> fees
        </Typography>
      </div>

      {isDismissible && (
        <Icon
          size="md"
          name="cross"
          hoverEffect="circle"
          aria-label="Close alert"
          className="lg:text-textSecondary absolute top-5 right-4 text-white"
          onClick={() => {
            setIsTopBannerDismissed(true);
          }}
        />
      )}
    </div>
  );
};
